import { useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Paperclip, Loader2, FileCheck2, X } from "lucide-react";
import { toast } from "sonner";

export function FileUpload({ value, onChange, testid = "file-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange({ id: data.id, filename: data.filename });
      toast.success("Pièce jointe ajoutée.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp" className="hidden" onChange={handle} data-testid={`${testid}-input`} />
      {value?.id ? (
        <div className="flex items-center gap-2 rounded-md border bg-muted/40 px-3 py-2 text-sm">
          <FileCheck2 className="h-4 w-4 text-success shrink-0" />
          <span className="truncate flex-1">{value.filename}</span>
          <button type="button" onClick={() => onChange(null)} className="text-muted-foreground hover:text-destructive" data-testid={`${testid}-remove`}>
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <Button type="button" variant="outline" className="w-full gap-2" onClick={() => inputRef.current?.click()} disabled={uploading} data-testid={`${testid}-btn`}>
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Paperclip className="h-4 w-4" />}
          Joindre un justificatif (PDF, JPG, PNG)
        </Button>
      )}
    </div>
  );
}
